import React from "react";
import {
  LinearProgress,
  Box,
  Typography,
  Stack
} from "@mui/material";
import { useTheme } from "@mui/system";

const AutobiaProgressBar = ({
  value,
  label,
  showPercentage = true,
  variant = "determinate",
  color = "primary",
  size = "medium",
  helperText,
  backgroundColor,
  borderRadius = "4px",
}) => {
  const theme = useTheme();

  const height = size === "small" ? 4 : size === "large" ? 12 : 8;

  return (
    <Stack spacing={1} sx={{ width: "100%" }}>
      {(label || showPercentage) && (
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          {label && (
            <Typography
              variant="body2"
              color={theme.palette.gray.g600}
              fontWeight={600}
            >
              {label}
            </Typography>
          )}
          {showPercentage && variant === "determinate" && (
            <Typography
              variant="body2"
              color={theme.palette.gray.g600}
              fontWeight={500}
            >
              {Math.round(value || 0)}%
            </Typography>
          )}
        </Stack>
      )}
      
      <LinearProgress
        variant={variant}
        value={value}
        color={color}
        sx={{
          height: height,
          borderRadius: borderRadius,
          backgroundColor: backgroundColor || theme.palette.gray.g100,
          "& .MuiLinearProgress-bar": {
            borderRadius: borderRadius,
            backgroundColor: color === "secondary"
              ? theme.palette.secondary.main
              : theme.palette.primary.main,
          },
          "& .MuiLinearProgress-bar1Indeterminate": {
            backgroundColor: color === "secondary"
              ? theme.palette.secondary.main
              : theme.palette.primary.main,
          },
          "& .MuiLinearProgress-bar2Indeterminate": {
            backgroundColor: color === "secondary"
              ? theme.palette.secondary.main
              : theme.palette.primary.main,
          },
        }}
      />
      
      {helperText && (
        <Typography
          variant="caption"
          color={theme.palette.gray.g500}
          sx={{ fontSize: "0.75rem" }}
        >
          {helperText}
        </Typography>
      )}
    </Stack>
  );
};

export default AutobiaProgressBar;